/* eslint-disable react/prop-types */
import React, { useContext, useState, useEffect } from 'react';
import { constantes } from '../../../constantes';
import Firebase from '../../../services/firebase';
import FirebaseContext from '../../../context/firebase.context';
import './atribuirNovoCadastro.scss';
import { notify } from '../../../functions/notifications';

function AtribuirNovoCadastro() {
  const { listUsuarios } = useContext(FirebaseContext);
  const [listaDisponiveis, setListaDisponiveis] = useState([]);
  const [listaHabilitados, setListaHabilitados] = useState([]);
  const [userSelected, setUserSelected] = useState({});
  const [disabledButton, setDisabledButton] = useState(true);
  const [userRecovered, setUserRecovered] = useState({});
  const db = Firebase.firestore();
  const { todos } = constantes;
  const entries = Object.values(todos).map(({ valor }) => valor);
  const todosArray = Object.values(todos);

  useEffect(() => {
    const { uid } = userSelected;
    if (uid && (uid !== '-- SELECIONE O USUÁRIO --')) {
      db.collection('users').doc(uid).onSnapshot((doc) => {
        const usuario = doc.data();
        setUserRecovered(usuario);
        const { premissoes } = usuario;
        const permitidosUsuario = premissoes.map((item) => item.permitido.valor);
        const disponiveis = entries.filter((item) => !permitidosUsuario.includes(item) && item);
        const listaDosDisponiveis = disponiveis.map((item) => ({
          permitido: todosArray.find((result) => {
            if (result.valor === item) {
              return item;
            }
            return null;
          }),
        }));
        setListaHabilitados(premissoes,
          setListaDisponiveis(listaDosDisponiveis,
            setDisabledButton(false)));
      });
    } else {
      setListaDisponiveis([],
        setListaHabilitados([],
          setUserSelected({},
            setDisabledButton(true,
              setUserRecovered({})))));
    }
  }, [userSelected.uid]);

  function cancelRecord() {
    setListaDisponiveis([],
      setListaHabilitados([],
        setUserSelected({},
          setDisabledButton(true,
            setUserRecovered({})))));
  }

  function updateRecords(props) {
    setUserSelected({
      ...userRecovered,
      premissoes: props,
    });
  }

  function add(props) {
    const novaDisponiveis = listaDisponiveis.filter((item) => (
      item.permitido.valor !== props.permitido.valor && item
    ));
    updateRecords([...listaHabilitados, props]);
    setListaHabilitados((prevState) => (
      [...prevState,
        props,
      ]
    ));
    setListaDisponiveis(novaDisponiveis);
  }

  function remove(props) {
    const novaListaHabilitados = listaHabilitados.filter((item) => (
      item.permitido.valor !== props.permitido.valor
    ));
    setListaDisponiveis((prevState) => (
      [...prevState,
        props,
      ]
    ), setListaHabilitados(novaListaHabilitados, updateRecords(novaListaHabilitados)));
  }

  function saveChanges() {
    const { uid } = userSelected;
    Firebase.firestore().collection('users').doc(uid).update(userSelected)
      .then(() => {
        cancelRecord();
        notify('success', 'Alterações realizadas com sucesso.');
      });
  }

  return (
    <div id="atribuir-usuario">
      <div className="header-atribuir">
        <label id="label-usuario" className="usuario">
          <span>
            Selecione o usuário.
          </span>
          <select
            className="form-control"
            name="usuario"
            id="usuario"
            onChange={(e) => setUserSelected({ uid: e.target.value })}
          >
            <option
              selected={disabledButton}
              value="-- SELECIONE O USUÁRIO --"
            >
              -- SELECIONE O USUÁRIO --
            </option>
            {listUsuarios?.length > 0 && listUsuarios.map((user) => (
              <option
                value={user.uid}
              >
                {`${user.nome}, ${user.cidade}-${user.estado} | ${user.celular}`}
              </option>
            ))}
          </select>
        </label>
        {/* <label id="label-cpfCnpj" className="cpfCnpj">
          <span>
            Pesquisar por Cpf ou Cnpj.
          </span>
          <input
            onChange={() => {}}
            type="text"
            required
            id="cpfCnpj"
            name="cpfCnpj"
            placeholder="Informe o CPF ou CNPJ"
          />
        </label> */}
      </div>
      <div className="body-atribuir">
        <div>
          <div className="separator">
            <span>
              Remover ou Atribuir Cadastros
            </span>
          </div>
        </div>
        <di className="seletorOptions">
          <div className="atribuir-left">
            <div className="atribuir-disponiveis">
              <i className="far fa-bookmark">
                <span>
                  Dispoíveis
                </span>
              </i>
            </div>
            {
              listaDisponiveis.map((item) => (
                <div className="lista-atributos">
                  <button
                    onClick={() => {
                      add(item);
                    }}
                    type="button"
                    className="buttons-transparent"
                  >
                    <span>
                      {item.permitido.valor}
                    </span>
                  </button>
                </div>
              ))
            }
          </div>
          <div className="atribuir-right">
            <div className="atribuir-disponiveis">
              <i className="fas fa-bookmark">
                <span>
                  Habilitados
                </span>
              </i>
            </div>
            {
              listaHabilitados.map((item) => (
                <div className="lista-atributos">
                  <button
                    onClick={() => {
                      remove(item);
                    }}
                    type="button"
                    className="buttons-transparent"
                  >
                    <span>
                      {item.permitido.valor}
                    </span>
                  </button>
                </div>
              ))
            }
          </div>
        </di>
        <div className="botao-salvar">
          <button
            onClick={() => saveChanges()}
            type="button"
            disabled={disabledButton}
            className="btn btn-dark btn-sm"
          >
            Salvar Alterações
          </button>
          <button
            onClick={() => {
              cancelRecord();
              notify('success', 'Alterações canceladas');
            }}
            type="button"
            disabled={disabledButton}
            className="btn btn-dark btn-sm"
          >
            Cancelar Alterações
          </button>
        </div>
      </div>
    </div>
  );
}

export default AtribuirNovoCadastro;
